import {ModifiedTag} from 'src/components/TagAssignment';

import {
  PageInfo,
  ProjectFragmentFragment,
  RegistrySearchArtifactMembershipsFragmentFragment,
  RegistrySearchCollectionFragmentFragment,
} from '../../../generated/graphql';

export type RegistrySearchCollectionType = {
  entityName: string;
  projectName: string;
  registryName: string;
  collectionId: string;
  projectId: string;
  artifactTypeName: string;
  collectionName: string;
  tags: ModifiedTag[];
  createdAt: string;
  isPortfolio: boolean;
  description?: string;
  lastUpdatedAt: string;
  initialMemberships?: GQLArtifactCollectionMembershipConnectionType;
  isArtifactMatch: boolean;
  protectedArtifactAliases?: string[];
};

export type ArtifactCollectionMembershipType = {
  membershipId: string;
  versionIndex?: number;
  createdAt: string;
  aliases: string[];
  tags: ModifiedTag[];
  metadata: string;
  size: number;
  usedCount: number;
  artifactId: string;
};

type GQLArtifactCollectionType =
  | RegistrySearchCollectionFragmentFragment
  | undefined
  | null;

export type GQLArtifactCollectionMembershipType =
  | RegistrySearchArtifactMembershipsFragmentFragment
  | undefined
  | null;

export type GQLArtifactCollectionMembershipConnectionType = {
  edges: {
    node?: GQLArtifactCollectionMembershipType;
  }[];
  pageInfo: PageInfo;
};

export type GQLArtifactCollectionSearchEdgeType = {
  node: GQLArtifactCollectionType;
  cursor: string;
  artifactMatch: boolean;
  lastUpdatedAt: string;
  artifactMemberships: GQLArtifactCollectionMembershipConnectionType;
};

export type GQLRegistryProjectType = ProjectFragmentFragment & {
  id: string;
};

export enum CardCollectionType {
  DEFAULT, // Deprecated, avoid using this going forward.
  REGISTRY_SEARCH, // Global registry search
  SINGLE_REGISTRY, // Within a single registry, including legacy model registry
}

export type GQLRegistryProjectViewerMembershipType = {
  id: string;
  member?: {
    id: string;
    name: string;
  } | null;
  teamMembers?: Array<{
    team: {
      id: string;
      member?: {
        id: string;
        name: string;
      } | null;
    };
  }>;
};
